import React from 'react';
import classNames from 'classnames';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import css from './SubscriptionSummary.css';

const SubscriptionSummary = props => {
  const { currentListing, isSubmitting, intl } = props;
  const { title, price, minDurationMonths } = currentListing.attributes;

  const firstImage = currentListing.images?.[0];
  const imageUrl = firstImage?.attributes?.variants?.['square-small']?.url ||
    firstImage?.attributes?.variants?.['landscape-crop']?.url;

  const provider = currentListing.provider;
  const storeName = provider?.attributes?.name;

  const initialAmount = price.amount * (minDurationMonths || 1);
  const initialPrice = { ...price, amount: initialAmount };

  return (
    <aside className={css.root}>
      <h2 className={css.heading}>
        <FormattedMessage id="SubscriptionSummary.title" />
      </h2>

      <div className={css.productCard}>
        <div className={css.productHeader}>
          {imageUrl ? (
            <img src={imageUrl} alt={title} className={css.productImage} />
          ) : (
            <div className={css.imagePlaceholder} />
          )}
          <div className={css.titleWrapper}>
            <h3 className={css.productTitle}>{title}</h3>
            <div className={css.shopName}>
              <span>{storeName}</span>
            </div>
            <div className={css.productMeta}>
              <span className={css.metaItem}>
                {formatMoney(intl, price)} / <FormattedMessage id="SubscriptionSummary.monthShort" />
              </span>
              <span className={css.metaSeparator}>•</span>
              <span className={css.metaItem}>
                <FormattedMessage id="SubscriptionSummary.minDurationShort" values={{ count: minDurationMonths }} />
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className={css.priceSection}>
        {/* Rozbicie płatności - "Paragon" */}
        <div className={css.breakdown}>
          <div className={css.breakdownRow}>
            <span className={css.breakdownLabel}>
              <FormattedMessage
                id="SubscriptionSummary.initialPaymentLabel"
                values={{ count: minDurationMonths || 1 }}
              />
            </span>
            <span className={css.breakdownValue}>{formatMoney(intl, initialPrice)}</span>
          </div>

          <div className={css.futurePayment}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={css.repeatIcon}>
              <path d="M17 1l4 4-4 4" />
              <path d="M3 11V9a4 4 0 0 1 4-4h14" />
              <path d="M7 23l-4-4 4-4" />
              <path d="M21 13v2a4 4 0 0 1-4 4H3" />
            </svg>
            <FormattedMessage
              id="SubscriptionSummary.futurePaymentNote"
              values={{
                amount: <strong>{formatMoney(intl, price)}</strong>
              }}
            />
          </div>
        </div>
      </div>
      <div className={css.stickyButtonWrapper}>
        <button
          type="submit"
          form="checkout-form"
          className={classNames(css.submitButton, { [css.submitButtonProcessing]: isSubmitting })}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <div className={css.loaderContainer}>
              <span className={css.spinner} />
              <FormattedMessage id="SubscriptionSummary.processing" />
            </div>
          ) : (
            <FormattedMessage
              id="SubscriptionSummary.submitWithPrice"
              values={{ price: formatMoney(intl, initialPrice) }}
            />
          )}
        </button>
      </div>
      {/* <div className={css.infoBox}>
        <p className={css.infoText}>
          <FormattedMessage id="SubscriptionSummary.notice" />
        </p>
      </div> */}
    </aside>
  );
};

export default injectIntl(SubscriptionSummary);